
export function getTimeZoneByLocaleTimeZone(localeTimeZone: string): string {
  switch (localeTimeZone) {
    case 'America/New_York':
      return 'EST';
    case 'America/Chicago':
      return 'CST';
    case 'America/Denver':
      return 'MST';
    case 'America/Los_Angeles':
      return 'PST';
    case 'America/Anchorage':
      return 'AKST';
    case 'Pacific/Honolulu':
      return 'HST';
    default:
      return localeTimeZone;
  }
}

export function getTimeZoneIdByTimeZone(timeZone: string): string {
  switch (timeZone) {
    case 'EST':
      return 'America/New_York';
    case 'CST':
      return 'America/Chicago';
    case 'MST':
      return 'America/Denver';
    case 'PST':
      return 'America/Los_Angeles';
    case 'AKST':
      return 'America/Anchorage';
    case 'HST':
      return 'Pacific/Honolulu';
    default:
      return timeZone;
  }
}
